import "./AssetManagerSingleCardTemplate.css";

import { ReactNode } from "react";

import { ArrowFullLeftDarkIcon } from "../../assets";
import { SeedActiveElement } from "../../models";
import { Button, Column, FullPageCard, Row, SeedFooter, SeedNavigation } from "../../widget";

interface AssetManagerSingleCardTemplateProps {
  pageTitle: string | undefined;
  children: ReactNode;
  activeElement?: SeedActiveElement;
  handleBackClick?: () => void;
  backButtonText?: string;
}

export const AssetManagerSingleCardTemplate = ({
  pageTitle,
  children,
  activeElement,
  handleBackClick,
  backButtonText = "Back",
}: AssetManagerSingleCardTemplateProps): JSX.Element => {
  return (
    <div className="AssetManagerSingleCardTemplate">
      <SeedNavigation activeElement={activeElement} />
      <div className="AssetManagerSingleCardTemplateContainer">
        {handleBackClick && (
          <div className="HeaderContainer">
            <Button
              text={backButtonText}
              variant="secondary"
              icon={<ArrowFullLeftDarkIcon />}
              iconPosition="left"
              onClick={handleBackClick}
              hasNoPadding
              minWidth={false}
            />
          </div>
        )}
        <Row spacingV="ll">
          <Column span={12}>
            <h1>{pageTitle}</h1>
          </Column>
        </Row>
        <FullPageCard corners="rounded" paddingBottom="l">
          {children}
        </FullPageCard>
        <SeedFooter />
      </div>
    </div>
  );
};
